// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lH0P","index":"styles_index__3eEHm"};